import {useEffect, useRef, useState} from 'react';
import classnames from 'classnames';

import {ConfirmCancelButton, ValidationMessage} from 'src/components';

import './styles.css';

type Props = {
  placeholder?: string,
  onChange: (newValue: string | undefined) => void,
  value?: string,
  validationMessage?: string,
}
type ButtonProps = Parameters<typeof ConfirmCancelButton>[0]

export const ConfirmCancelInput = ({
  onOpen = () => true,
  onConfirm = () => true,
  onCancel = () => true,
  onChange = () => {},
  value,
  placeholder,
  validationMessage,
  ...rest
}: ButtonProps & Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hasFailedConfirm, setHasFailedConfirm] = useState(false);
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const {current} = ref;
    if (current && isOpen) {
      current.focus();
    }
  }, [isOpen]);

  return (
    <div className="ConfirmCancelInput">
      <div className={classnames({
        'ConfirmCancelInput__content': true,
        'ConfirmCancelInput__content--open': isOpen,
      })}>
        <input
          ref={ref}
          className="ConfirmCancelInput__input"
          value={value}
          placeholder={placeholder}
          onChange={(e) => {
            const {target: {value}} = e;
            onChange(value);
          }}
          type="text"
        />
        <ValidationMessage visible={hasFailedConfirm} isValid={false}>
          {validationMessage}
        </ValidationMessage>
      </div>
      <div className="ConfirmCancelInput__controls">
        <ConfirmCancelButton
          {...rest}
          onConfirm={async () => {
            const shouldContinue = await onConfirm();
            if (shouldContinue) {
              setIsOpen(false);
              setHasFailedConfirm(false);
              return true;
            } else {
              setHasFailedConfirm(true);
              return false;
            }
          }}
          onCancel={async () => {
            const shouldContinue = await onCancel();
            if (shouldContinue) {
              setIsOpen(false);
              setHasFailedConfirm(false);
              return true;
            }
            return false;
          }}
          onOpen={async () => {
            const shouldContinue = await onOpen();
            if (shouldContinue) {
              setIsOpen(true);
              return true;
            }
            return false;
          }}
        />
      </div>
    </div>
  );
};

